import React from "react";
import SavedJobs from "../components/SavedJobs/SavedJobs";

const SavedJobsPage = () => {
  return <SavedJobs />;
};

export default SavedJobsPage;
